/* eslint-disable global-require */
const getEmailDistributionList = () => {
  let isLocal = false;

  if (
    window.location.hostname.startsWith(process.env.REACT_APP_LOCAL_ENV) ||
    window.location.hostname.startsWith(process.env.REACT_APP_DEV_ENV) ||
    window.location.hostname.startsWith(process.env.REACT_APP_TEST_ENV)
  ) {
    isLocal = true;
  }
  const emailDistributionList = isLocal
    ? require('../distribution/dev.emailDistributionList.json')
    : require('../distribution/emailDistributionList.json');
  return emailDistributionList;
};
export default getEmailDistributionList;
